import { SxProps, Theme } from "@mui/material";
import { COLORS } from "../../../values/colors";

export const buttonSx: SxProps<Theme> = {
  borderRadius: "999px",
  textTransform: "none",
  fontWeight: 700,
  minWidth: "11rem",
  maxWidth: "100%",
};

export const bannerWrapperSx: SxProps<Theme> = {
  position: "fixed",
  insetInline: 0,
  bottom: 0,
  zIndex: 1600,
  boxSizing: "border-box",
  padding: {
    xs: "0.5rem 0.5rem calc(0.5rem + env(safe-area-inset-bottom, 0px))",
    sm: "1rem",
    md: "1.4rem",
  },
};

export const bannerPaperSx: SxProps<Theme> = {
  maxWidth: "72rem",
  width: { xs: "calc(100vw - 1rem)", sm: "100%" },
  margin: "0 auto",
  maxHeight: { xs: "calc(100vh - 6rem)", sm: "none" },
  overflowY: { xs: "auto", sm: "visible" },
  boxSizing: "border-box",
  padding: { xs: "0.85rem", sm: "1.1rem", md: "1.4rem" },
  borderRadius: { xs: "1.1rem", sm: "1.3rem", md: "1.6rem" },
  color: COLORS.white,
  background:
    "linear-gradient(180deg, rgba(19,19,19,0.98), rgba(10,10,10,0.98))",
  border: "1px solid rgba(181,115,76,0.26)",
  boxShadow: "0 24px 70px rgba(0,0,0,0.38)",
};

export const bannerTitleSx: SxProps<Theme> = {
  color: COLORS.apronBrown,
  letterSpacing: "0.18em",
  display: "block",
  marginBottom: "0.15rem",
};

export const bannerHeadlineSx: SxProps<Theme> = {
  fontWeight: 800,
  fontSize: { xs: "1.15rem", sm: "1.35rem", md: "1.5rem" },
  lineHeight: 1.25,
};

export const bannerChipSx: SxProps<Theme> = {
  alignSelf: "flex-start",
  maxWidth: { xs: "100%", md: "unset" },
  width: { xs: "100%", sm: "auto" },
  boxSizing: "border-box",
  color: COLORS.creamWhite,
  backgroundColor: "rgba(181,115,76,0.14)",
  border: "1px solid rgba(181,115,76,0.26)",
  fontSize: { xs: "0.78rem", sm: "0.8125rem" },
  "& .MuiChip-label": {
    display: "block",
    whiteSpace: "normal",
    textAlign: "center",
    lineHeight: 1.3,
    padding: { xs: "0.32rem 0.7rem", sm: "0.28rem 0.75rem" },
  },
};

export const bannerDescriptionSx: SxProps<Theme> = {
  color: "rgba(255,255,255,0.78)",
  lineHeight: { xs: 1.6, sm: 1.7 },
  fontSize: { xs: "0.9rem", sm: "1rem" },
};

export const dialogPaperSx: SxProps<Theme> = {
  borderRadius: { xs: 0, sm: "1.4rem" },
  margin: { xs: 0, sm: 2 },
  maxHeight: { xs: "100%", sm: "calc(100% - 2rem)" },
};

export const dialogTitleSx: SxProps<Theme> = {
  paddingBottom: 0,
  paddingInline: { xs: "1rem", sm: "1.5rem" },
  paddingTop: { xs: "1rem", sm: "1.5rem" },
};

export const dialogHeadlineSx: SxProps<Theme> = {
  fontWeight: 800,
  fontSize: { xs: "1.15rem", sm: "1.45rem" },
  lineHeight: 1.25,
};

export const dialogContentSx: SxProps<Theme> = {
  paddingInline: { xs: "1rem", sm: "1.5rem" },
  paddingBottom: { xs: "1rem", sm: "1.25rem" },
};

export const introTextSx: SxProps<Theme> = {
  color: "rgba(0,0,0,0.76)",
  lineHeight: 1.7,
  fontSize: { xs: "0.95rem", sm: "1rem" },
};

export const categoryCardSx: SxProps<Theme> = {
  padding: { xs: "0.9rem", sm: "1rem" },
  borderRadius: "1rem",
  border: "1px solid rgba(0,0,0,0.08)",
};

export const categoryTextWrapperSx: SxProps<Theme> = {
  maxWidth: "42rem",
  width: "100%",
};

export const categoryTitleSx: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: { xs: "1rem", sm: "1.05rem" },
};

export const categoryDescriptionSx: SxProps<Theme> = {
  color: "rgba(0,0,0,0.7)",
  lineHeight: 1.65,
  marginTop: "0.35rem",
  fontSize: { xs: "0.93rem", sm: "1rem" },
};

export const categoryMetaSx: SxProps<Theme> = {
  color: "rgba(0,0,0,0.55)",
  marginTop: "0.45rem",
};

export const categoryToggleSx: SxProps<Theme> = {
  marginLeft: 0,
  width: { xs: "100%", md: "auto" },
  justifyContent: { xs: "space-between", md: "flex-end" },
  gap: 1,
};

export const dialogActionsSx: SxProps<Theme> = {
  padding: {
    xs: "0 1rem calc(1rem + env(safe-area-inset-bottom, 0px))",
    sm: "0 1.5rem 1.5rem",
  },
  gap: "0.75rem",
  justifyContent: "flex-start",
  flexWrap: "wrap",
};
